import React, { Component } from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import '../../style/generic.css';
import '../../style/protagonisti.css';
import * as Constanti from '../../Utils/constants.js';


class Protagonisti extends Component{
  constructor(props){
    
    super(props);
  }
      
  


  render(){
    return (
    <> 
    <div className="flex horizontal padding-top-32 mobileProt">
    { this.props.protagonisti != null && this.props.protagonisti?.map(el => (
      <Link to={'/protagonisti/'+el.id} key={el}>
     <div  className="flex vertical" >
    
     <img src={Constanti.url_img_new+el.foto} alt="protagonista" className="avatar"></img>
     <span className="namePersonaggio">{el.nome} {el.cognome}</span>
     </div>
     </Link>
    )
    )
    }
    </div>
    </>
    )
}
}

export default (props) => (
  <Protagonisti
      {...props}
      params={useParams()}
  />);